import { getModal } from '~/selectors';
import { ModalTypes } from '~/constants';

export const addFileToImageGallery = (file) => (dispatch, getState) => {
  const state = getState();

  const imageGalleryModalRef = getModal(ModalTypes.IMAGE_GALLERY)(state).ref;

  const addFile = imageGalleryModalRef?.current?.addFile;

  if (typeof addFile === 'function') {
    addFile(file);
  }
};
